import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-decisao-certa',
  templateUrl: './decisao-certa.component.html',
  styleUrls: ['./decisao-certa.component.scss']
})
export class DecisaoCertaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
